// src/components/ScrollToTop.js
// Resets scroll position to the top on every route change.
// Skips if the URL contains a hash (e.g. /services#waste-collection) so that
// anchor-scroll behaviours in destination pages are not overridden.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
